<template> 

    <span>
            
        <div class="ibox">

            <div class="ibox-content">
                    
                <div class='row' style='margin-left: 0px'>

                    <form :gaction="path" method="get">
                    
                        <div class='col-md-2'>
                        
                            <label for='data_anterior'>Data da publicação</label>
                            <select class="form-control" id='data_anterior' name="data_anterior">
                                <option value='0' :selected="data_anterior == '' ? 'selected' : ''">Hoje</option>
                                <option value='1' :selected="data_anterior == 1 ? 'selected' : ''">1 dia atrás</option>
                                <option value='2' :selected="data_anterior == 2 ? 'selected' : ''">2 dias atrás</option>
                                <option value='3' :selected="data_anterior == 3 ? 'selected' : ''">3 dias atrás</option>
                                <option value='4' :selected="data_anterior == 4 ? 'selected' : ''">4 dias atrás</option>
                                <option value='5' :selected="data_anterior == 5 ? 'selected' : ''">5 dias atrás</option>
                                <option value='10' :selected="data_anterior == 10 ? 'selected' : ''">10 dias atrás</option>
                            </select>

                        </div>

                        <div class='col-md-2'>
                        
                            <label for='area'>Area</label>
                            <select class="form-control" id='area' name="area">
                                <option value='1' :selected="area == 1 ? 'selected' : ''">Minhas Areas</option>
                            </select>

                        </div>

                        <div class='col-md-2'>
                        
                            <label for='uf'>UF</label>
                            <select class="form-control" id='uf' name="uf">
                                <option value='1' :selected="uf == 1 ? 'selected' : ''">Minha UF</option>
                                <option v-for="(location, index) in locations" :value="location.id" :selected="uf == location.id ? 'selected' : ''">{{ location.state_name }}</option>
                            </select>

                        </div>
                        
                        <div class='col-md-2' v-if="publicacoesVisualizadas">
                        
                            <label for='visualizacao'>Dados Visualizados</label>
                            <select class="form-control" id='visualizacao' name="visualizacao">
                                <option value='1' :selected="visualizacao == 1 ? 'selected' : ''">Não Filtrar</option>
                                <option value='3' :selected="visualizacao == 3 ? 'selected' : ''">Somente Autor</option>
                                <option value='2' :selected="visualizacao == 2 ? 'selected' : ''">Somente Reu</option>
                                <option value='4' :selected="visualizacao == 4 ? 'selected' : ''">Autor e Reu</option>
                            </select>

                        </div>

                        <div class="col-md-2" style="margin-top: 10px; width: fit-content">
    
                            <button type="submit" class='btn btn-primary' style="transform: translateY(40%);">
                                <i class="fa fa-search"></i> Pesquisar
                            </button>
                    
                        </div>

                    </form>

                    <div class="col-md-2" style="margin-top: 10px; width: fit-content">

                        <a v-if="!publicacoesVisualizadas" style="transform: translateY(40%);" class='btn btn-warning' href="minhas_publicacoes">
                            <i class="fa fa-eye"></i> Publicações Visualizadas
                        </a>

                        <a v-if="publicacoesVisualizadas" style="transform: translateY(40%);" class='btn btn-warning' href="publicacoes">
                            <i class="fa fa-eye"></i> Todas as Publicações
                        </a>

                    </div>  

                </div>

            </div>

        </div>
                
    </span>

</template>

<script> 

    export default {  
        
        props: ['locations'],
        data: function() {
            
            return {
            
                publicacoesVisualizadas: false,
                path: window.location.pathname,
                visualizacao: this.urlParam('visualizacao'),
                area: '',
                data_anterior: '',
                uf: '',
                fields: ''
            
            }

        },
        mounted() {

            //Checa o caminho para desenhar o botão correto
            //
            if(this.path == '/minhas_publicacoes')
                this.publicacoesVisualizadas = true; 
            
            else{

                //Adiciona limite maximo e minimo nos campos date na tela de publicações
                //

                var date  = new Date();
                var month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
                var day   = (date.getDate() < 10 ? '0' : '') + date.getDate();
                var year  = date.getFullYear();

                var max_date = year + '-' + month + '-' + day;
                var min_date = year + '-' + month + '-' + (day - 5);

                $("#data_inicial, #data_final").attr("max", max_date).attr("min", min_date);
            
            }

            //Define o valor padrão dos campos caso já tenham sido usados
            //
            $("#data_inicial").val(this.urlParam('data_inicial'));
            $("#data_final").val(this.urlParam('data_final'));

            this.area = this.urlParam('area');
            this.uf   = this.urlParam('uf');
            this.data_anterior = this.urlParam('data_anterior');
            
            //Pega todas as areas
            //
            fetch(window.location.origin + '/publicacoes/keywords', {
                method: 'GET',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
            .then(response => response.json())
            .then(data => {
                
                const areaSelect = document.getElementById('area');
                
                data.forEach(value => {
                    const option = document.createElement('option');
                    option.value = value.id;
                    option.textContent = value.name;
                    
                    if (this.area == value.id) {
                        option.selected = true;
                    }
                    
                    areaSelect.appendChild(option);
                });
                
            })
            .catch(error => {
                console.error('Erro na requisição: ' + error);
            });  

            //Limpar URL
            //
            window.history.pushState("object or string", "Title", window.location.href.replace(window.location.search,''));

        },
        methods: {

            urlParam(name) {

                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

                if(results)
                    return results[1];
                else
                    return 0;

            } 

        }
    
    }

</script>